var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFollowBlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "follow-blocked_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 653 294.8",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".follow-blocked_svg__st2{fill:#2bc3f7}.follow-blocked_svg__st3{fill:#9fe791}.follow-blocked_svg__st4{opacity:.15}.follow-blocked_svg__st5{fill:#32caf8}.follow-blocked_svg__st6{fill:#a9ea9c}.follow-blocked_svg__st7{fill:#91cd86}.follow-blocked_svg__st8{fill:#426572}.follow-blocked_svg__st9{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "follow-blocked_svg__Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "follow-blocked_svg__Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5,109.8h350c41.1,0,74.5,33.3,74.5,74.5l0,0l0,0c0,41.1-33.3,74.5-74.5,74.5l0,0h-350 C33.4,258.8,0,225.4,0,184.3l0,0l0,0C0,143.2,33.3,109.8,74.5,109.8L74.5,109.8z",
    opacity: 0.15,
    fill: "#a9ea9c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.5,73.8h358c41.1,0,74.5,33.3,74.5,74.5l0,0l0,0c0,41.1-33.3,74.5-74.5,74.5l0,0h-358 c-41.1,0-74.5-33.3-74.5-74.5l0,0l0,0C146,107.2,179.3,73.8,220.5,73.8L220.5,73.8z",
    opacity: 0.15,
    fill: "#32caf8"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "follow-blocked_svg__st2",
    cx: 151.5,
    cy: 287.3,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "follow-blocked_svg__st2",
    cx: 528.5,
    cy: 280.3,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "follow-blocked_svg__st3",
    cx: 566.7,
    cy: 110.1,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "follow-blocked_svg__st3",
    cx: 475.5,
    cy: 37.3,
    r: 7.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "follow-blocked_svg__st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "follow-blocked_svg__st5",
    d: "M138.4,68.5l-14.2,11.8c-3,2.5,1.3,6.7,4.2,4.2l14.2-11.8C145.6,70.3,141.3,66.1,138.4,68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "follow-blocked_svg__st5",
    d: "M141.4,81.5l-11.8-14.2c-2.5-3-6.7,1.3-4.2,4.2l11.8,14.2C139.6,88.8,143.8,84.5,141.4,81.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "follow-blocked_svg__st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "follow-blocked_svg__st5",
    d: "M603.6,261l-14.2,11.8c-3,2.5,1.3,6.7,4.2,4.2l14.2-11.8C610.8,262.8,606.6,258.6,603.6,261z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "follow-blocked_svg__st5",
    d: "M606.6,274.1l-11.8-14.2c-2.5-3-6.7,1.3-4.2,4.2l11.8,14.2C604.9,281.3,609.1,277,606.6,274.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "follow-blocked_svg__st6",
    d: "M359,182.2h-64.1c-8.6,0-15.5-7-15.5-15.6V79.2c0-8.6,7-15.5,15.5-15.5H359c8.6,0,15.5,6.9,15.5,15.5v87.4 C374.6,175.2,367.6,182.2,359,182.2z M298.8,162.8h56.3V83.2h-56.3V162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "follow-blocked_svg__st7",
    d: "M374.7,111.3v59.2c0,8.6-7,15.5-15.5,15.5h-64.1c-8.6,0-15.6-6.9-15.6-15.5l0,0v-59.2h19.4v55.3h56.3v-55.3 C355.2,111.3,374.7,111.3,374.7,111.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "follow-blocked_svg__st8",
    d: "M359,188.6h-64.1c-10.8,0-19.5-8.7-19.5-19.5V81.7c0-10.8,8.7-19.5,19.5-19.5H359c10.8,0,19.5,8.7,19.5,19.5 v87.4C378.6,179.9,369.8,188.6,359,188.6z M295,70.2c-6.4,0-11.5,5.2-11.5,11.5v87.4c0,6.4,5.2,11.5,11.5,11.5h64.1 c6.4,0,11.5-5.2,11.5-11.5V81.7c0-6.4-5.2-11.5-11.5-11.5H295z M359.2,169.2h-64.3V81.6h64.3V169.2z M302.9,161.2h48.3V89.6 h-48.3V161.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "follow-blocked_svg__st6",
    d: "M278.5,122.1h96c6.6,0,12,5.4,12,12v83.5c0,6.6-5.4,12-12,12h-96c-6.6,0-12-5.4-12-12v-83.5 C266.5,127.5,271.9,122.1,278.5,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "follow-blocked_svg__st7",
    d: "M387.5,135.5v81.1c0,7.3-5.9,13.2-13.2,13.2h-38.2c-4.2,0-7.6-3.4-7.6-7.6l0,0V130c0-4.2,3.4-7.6,7.6-7.6 h38.2C381.6,122.3,387.5,128.2,387.5,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "follow-blocked_svg__st8",
    d: "M374.5,232.6h-96c-8.8,0-16-7.2-16-16v-83.5c0-8.8,7.2-16,16-16h96c8.8,0,16,7.2,16,16v83.4 C390.5,225.4,383.3,232.6,374.5,232.6L374.5,232.6z M278.5,125.1c-4.4,0-8,3.6-8,8v83.5c0,4.4,3.6,8,8,8h96c4.4,0,8-3.6,8-8 v-83.5c0-4.4-3.6-8-8-8H278.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "follow-blocked_svg__st9",
    cx: 288.3,
    cy: 136.4,
    rx: 7.6,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "follow-blocked_svg__st9",
    cx: 321,
    cy: 136.4,
    rx: 18.9,
    ry: 2.6
  })))));
}

export default SvgFollowBlocked;